// Kurátált európai + japán autómárkák és modelljeik.
// Lokális adatbázis — gyorsan tölt, offline is működik, márkánként csak az adott modelleket adja.
// Backend szinkron: `backend/data/vehicle_catalog.json` (node export a CATALOG-ból deploy előtt).

import { enginesForMakeModel } from "./carEngineCatalog";

const CATALOG = {
  // ── Európai márkák ────────────────────────────────────────────
  Audi: ["A1", "A3", "A4", "A5", "A6", "A7", "A8", "Q2", "Q3", "Q4 e-tron", "Q5", "Q7", "Q8", "e-tron", "e-tron GT", "TT", "R8", "RS3", "RS4", "RS5", "RS6", "RS7", "RSQ8", "S3", "S4", "S5", "S6", "S8", "SQ5", "SQ7", "SQ8"],
  BMW: ["1-es sorozat", "2-es sorozat", "2-es Gran Coupé", "3-as sorozat", "4-es sorozat", "5-ös sorozat", "6-os sorozat", "7-es sorozat", "8-as sorozat", "X1", "X2", "X3", "X4", "X5", "X6", "X7", "XM", "Z4", "i3", "i4", "i5", "i7", "iX", "iX1", "iX3", "M2", "M3", "M4", "M5", "M8"],
  "Mercedes-Benz": ["A-osztály", "B-osztály", "C-osztály", "CLA", "CLS", "E-osztály", "S-osztály", "GLA", "GLB", "GLC", "GLE", "GLS", "G-osztály", "EQA", "EQB", "EQC", "EQE", "EQS", "EQV", "AMG GT", "AMG SL", "V-osztály", "Vito", "Sprinter", "Citan"],
  Volkswagen: ["Polo", "Golf", "Golf Variant", "Golf GTI", "Golf R", "ID.3", "ID.4", "ID.5", "ID.7", "ID. Buzz", "Jetta", "Passat", "Passat Variant", "Arteon", "T-Cross", "Taigo", "T-Roc", "Tiguan", "Tiguan Allspace", "Touareg", "Touran", "Sharan", "Caddy", "Transporter", "Multivan", "Amarok", "Up!"],
  Škoda: ["Citigo", "Fabia", "Scala", "Rapid", "Octavia", "Octavia Combi", "Superb", "Superb Combi", "Kamiq", "Karoq", "Kodiaq", "Enyaq", "Enyaq Coupé", "Yeti", "Roomster"],
  SEAT: ["Mii", "Ibiza", "Leon", "Leon ST", "Toledo", "Arona", "Ateca", "Tarraco", "Alhambra", "Altea"],
  Cupra: ["Born", "Formentor", "Leon", "Ateca", "Tavascan", "Terramar"],
  Opel: ["Corsa", "Corsa-e", "Astra", "Astra Sports Tourer", "Insignia", "Adam", "Karl", "Mokka", "Mokka-e", "Crossland", "Grandland", "Combo", "Combo Life", "Vivaro", "Vivaro-e", "Zafira", "Zafira Life", "Movano"],
  Ford: ["Ka+", "Fiesta", "Focus", "Focus ST", "Mondeo", "Puma", "EcoSport", "Kuga", "Edge", "Explorer", "Mustang", "Mustang Mach-E", "Galaxy", "S-Max", "C-Max", "B-Max", "Tourneo Connect", "Tourneo Courier", "Tourneo Custom", "Transit", "Ranger"],
  Renault: ["Twingo", "Clio", "Megane", "Megane Grandtour", "Megane E-Tech", "Talisman", "Captur", "Kadjar", "Koleos", "Arkana", "Austral", "Espace", "Zoe", "Scenic", "Grand Scenic", "Trafic", "Master", "Kangoo"],
  Peugeot: ["108", "208", "e-208", "308", "308 SW", "408", "508", "508 SW", "2008", "e-2008", "3008", "5008", "Rifter", "Partner", "Traveller", "Expert", "Boxer", "iOn"],
  Citroën: ["C1", "C3", "C3 Aircross", "C4", "C4 Cactus", "C4 X", "ë-C4", "C5", "C5 Aircross", "C5 X", "Berlingo", "SpaceTourer", "Jumpy", "Jumper", "Ami"],
  "DS Automobiles": ["DS 3", "DS 3 Crossback", "DS 4", "DS 5", "DS 7 Crossback", "DS 9"],
  Fiat: ["500", "500e", "500L", "500X", "600", "600e", "Panda", "Tipo", "Punto", "Bravo", "Doblo", "Ducato", "Fiorino", "Fullback", "Freemont"],
  "Alfa Romeo": ["Mito", "Giulietta", "Giulia", "Stelvio", "Tonale", "159", "Brera", "4C", "8C"],
  Lancia: ["Ypsilon", "Delta", "Musa", "Thema"],
  Volvo: ["V40", "V60", "V60 Cross Country", "V90", "V90 Cross Country", "S60", "S90", "XC40", "XC60", "XC90", "C30", "C40 Recharge", "EX30", "EX90"],
  Polestar: ["1", "2", "3", "4"],
  "Land Rover": ["Defender", "Discovery", "Discovery Sport", "Freelander", "Range Rover", "Range Rover Sport", "Range Rover Velar", "Range Rover Evoque"],
  Jaguar: ["XE", "XF", "XJ", "F-Type", "E-Pace", "F-Pace", "I-Pace"],
  MINI: ["Cooper", "Cooper S", "Cooper SE", "One", "Countryman", "Clubman", "Cabrio", "Paceman", "Coupé"],
  Porsche: ["911", "718 Cayman", "718 Boxster", "Panamera", "Cayenne", "Cayenne Coupé", "Macan", "Taycan", "Taycan Cross Turismo"],
  Dacia: ["Sandero", "Sandero Stepway", "Logan", "Logan MCV", "Duster", "Jogger", "Spring", "Lodgy", "Dokker"],
  Smart: ["ForTwo", "ForTwo EQ", "ForFour", "ForFour EQ", "#1", "#3"],
  Bentley: ["Continental", "Continental GT", "Flying Spur", "Bentayga", "Mulsanne", "Arnage"],
  "Rolls-Royce": ["Ghost", "Phantom", "Wraith", "Dawn", "Cullinan", "Spectre"],
  "Aston Martin": ["Vantage", "DB11", "DB12", "DBS", "DBX", "Rapide", "Vanquish"],
  Ferrari: ["Portofino", "Roma", "F8 Tributo", "296 GTB", "SF90", "Purosangue", "812 Superfast"],
  Lamborghini: ["Huracán", "Aventador", "Urus", "Revuelto"],
  Maserati: ["Ghibli", "Quattroporte", "Levante", "Grecale", "MC20", "GranTurismo"],
  Bugatti: ["Chiron", "Veyron", "Divo", "Mistral"],
  "McLaren": ["540C", "570S", "570GT", "600LT", "720S", "765LT", "Artura", "GT"],
  Lotus: ["Elise", "Exige", "Evora", "Emira", "Eletre", "Emeya"],
  Tesla: ["Model 3", "Model Y", "Model S", "Model X"],

  // ── Japán márkák ─────────────────────────────────────────────
  Toyota: ["Aygo", "Aygo X", "Yaris", "Yaris Cross", "Corolla", "Corolla Touring Sports", "Corolla Cross", "Camry", "Auris", "Auris Touring Sports", "Avensis", "Verso", "C-HR", "bZ4X", "RAV4", "Highlander", "Land Cruiser", "Land Cruiser Prado", "Prius", "Prius+", "Mirai", "GR86", "GR Yaris", "GR Supra", "Hilux", "Proace", "Proace City"],
  Lexus: ["CT", "IS", "ES", "LS", "UX", "NX", "RX", "GX", "LX", "RC", "LC", "RZ", "LBX", "LM"],
  Honda: ["Jazz", "Civic", "Civic Type R", "Accord", "HR-V", "CR-V", "ZR-V", "e:Ny1", "Insight", "e", "CR-Z", "S2000", "NSX", "Passport", "Pilot", "Ridgeline"],
  Nissan: ["Micra", "Note", "Note e-POWER", "Pulsar", "Leaf", "Ariya", "Juke", "Qashqai", "X-Trail", "Pathfinder", "Murano", "Navara", "NP300", "GT-R", "350Z", "370Z", "Z", "Skyline", "Almera"],
  Mazda: ["Mazda2", "Mazda3", "Mazda6", "CX-3", "CX-30", "CX-5", "CX-60", "CX-90", "MX-30", "MX-5", "RX-8", "BT-50"],
  Subaru: ["Impreza", "Forester", "Outback", "XV", "Crosstrek", "Legacy", "BRZ", "Solterra", "Levorg", "WRX", "Ascent"],
  Suzuki: ["Alto", "Swift", "Swift Sport", "Ignis", "Baleno", "Vitara", "S-Cross", "Jimny", "SX4", "SX4 S-Cross", "Across", "Splash", "Kizashi"],
  Mitsubishi: ["Space Star", "Mirage", "ASX", "Eclipse Cross", "Outlander", "Outlander PHEV", "L200", "Colt", "Lancer", "Pajero", "Pajero Sport", "i-MiEV"],
  Infiniti: ["Q30", "Q50", "Q60", "Q70", "QX30", "QX50", "QX55", "QX60", "QX70", "QX80"],
  Daihatsu: ["Terios", "Sirion", "Materia", "Copen", "Cuore"],

  // ── Koreai márkák ─────────────────────────────────────────────
  Kia: [
    "Picanto", "Rio", "Stonic", "Ceed", "Ceed Sportswagon", "Proceed", "XCeed", "Sportage", "Sorento",
    "Niro", "EV3", "EV6", "EV9", "Carnival", "Stinger", "Soul", "Optima", "Carens", "Venga", "Cee'd",
  ],
  Hyundai: [
    "i10", "i20", "i30", "i30 N", "Bayon", "Kona", "Tucson", "Santa Fe", "Ioniq", "Ioniq 5", "Ioniq 6",
    "Nexo", "Staria", "Getz", "Accent", "Elantra", "Sonata", "ix20", "ix35", "Matrix", "Coupe",
  ],
  Genesis: ["G70", "G80", "G90", "GV60", "GV70", "GV80"],

  // ── Amerikai / egyéb gyakori EU márkák ───────────────────────
  Jeep: ["Renegade", "Compass", "Cherokee", "Grand Cherokee", "Wrangler", "Gladiator", "Avenger"],
  Chrysler: ["300C", "Pacifica", "Voyager", "Grand Voyager", "PT Cruiser", "Sebring"],
  Dodge: ["Caliber", "Journey", "Nitro", "Charger", "Challenger", "Durango"],
  Chevrolet: ["Spark", "Aveo", "Cruze", "Malibu", "Captiva", "Trax", "Orlando", "Camaro", "Corvette"],
  Cadillac: ["CTS", "CT4", "CT5", "Escalade", "XT4", "XT5", "XT6"],
  Hummer: ["H2", "H3", "EV"],
  GMC: ["Terrain", "Acadia", "Yukon", "Sierra"],
  Lincoln: ["MKZ", "Continental", "Navigator", "Aviator", "Corsair"],
  Buick: ["Encore", "Envision", "Enclave", "Regal"],
  RAM: ["1500", "2500", "ProMaster"],
  Isuzu: ["D-Max", "MU-X"],
  SsangYong: ["Tivoli", "Korando", "Rexton", "Musso", "Kyron", "Rodius"],
  MG: ["MG3", "MG4", "MG5", "ZS", "HS", "Marvel R", "Cyberster"],
  BYD: ["Atto 3", "Dolphin", "Seal", "Han", "Tang"],
  Aiways: ["U5", "U6"],
  Maxus: ["eDeliver 3", "eDeliver 9", "T90", "Euniq 5"],
  Lada: ["Niva", "Granta", "Vesta", "Largus"],
  Abarth: ["500", "595", "695", "124 Spider"],
  Alpina: ["B3", "B4", "B5", "B7", "XB7", "D3", "D4", "D5"],
  Alpine: ["A110"],
  Caterham: ["Seven"],
  Morgan: ["Plus Four", "Plus Six"],
  Piaggio: ["Porter"],
  Iveco: ["Daily"],
};

/** Gyakori elírás / rövidítés → katalógus márkanév */
const MAKE_ALIASES = {
  vw: "Volkswagen",
  volkswagen: "Volkswagen",
  mercedes: "Mercedes-Benz",
  "mercedes benz": "Mercedes-Benz",
  "mercedes-benz": "Mercedes-Benz",
  skoda: "Škoda",
  seat: "SEAT",
  citroen: "Citroën",
  kia: "Kia",
  hyundai: "Hyundai",
  alfa: "Alfa Romeo",
  "alfa romeo": "Alfa Romeo",
  "land rover": "Land Rover",
  "range rover": "Land Rover",
  "ds automobiles": "DS Automobiles",
  ds: "DS Automobiles",
  chevy: "Chevrolet",
  ssangyong: "SsangYong",
  "ssang yong": "SsangYong",
  ab: "Abarth",
};

// Kis-nagybetű független illesztés, hogy pl. "audi" == "Audi"
const norm = (s) => (s || "").trim().toLowerCase();

const MAKES = Object.keys(CATALOG).sort((a, b) => a.localeCompare(b, "hu"));
const LOOKUP = Object.fromEntries(Object.entries(CATALOG).map(([k, v]) => [norm(k), v]));

const CANONICAL_MAKE = (() => {
  const m = {};
  for (const make of MAKES) m[norm(make)] = make;
  for (const [alias, target] of Object.entries(MAKE_ALIASES)) {
    const canon = m[norm(target)] || target;
    m[norm(alias)] = canon;
  }
  return m;
})();

/** Beírt vagy API-ból jövő márka → katalógusbeli pontos név, vagy null. */
export function resolveCanonicalMake(input) {
  const raw = (input || "").trim();
  if (!raw) return null;
  const direct = CANONICAL_MAKE[norm(raw)];
  if (direct) return direct;
  const n = norm(raw);
  if (n.length >= 2) {
    const prefixHits = MAKES.filter((m) => norm(m).startsWith(n));
    if (prefixHits.length === 1) return prefixHits[0];
    const containsHits = MAKES.filter((m) => norm(m).includes(n));
    if (containsHits.length === 1) return containsHits[0];
  }
  return null;
}

/** Modell → katalógusbeli pontos név adott márkához. */
export function resolveCanonicalModel(make, input) {
  const models = LOOKUP[norm(make)] || [];
  const raw = (input || "").trim();
  if (!raw || !models.length) return null;
  const nraw = norm(raw);
  const exact = models.find((m) => norm(m) === nraw);
  if (exact) return exact;
  for (const m of models) {
    if (norm(m).includes(nraw) || nraw.includes(norm(m))) return m;
  }
  const tokens = raw.split(/[\s/\-–+]+/).filter(Boolean);
  for (const token of tokens) {
    const t = norm(token);
    const hit = models.find((m) => norm(m) === t || norm(m).startsWith(t) || t.startsWith(norm(m)));
    if (hit) return hit;
  }
  return null;
}

export async function fetchMakes() {
  return MAKES;
}

export async function fetchModels(make) {
  const canon = resolveCanonicalMake(make) || make;
  if (!canon) return [];
  return LOOKUP[norm(canon)] || [];
}

export async function fetchEngines(make, model) {
  return enginesForMakeModel(make, model);
}

export async function fetchTrims(make, model, year) {
  const params = new URLSearchParams({ make, model });
  if (year) params.set("year", String(year));
  const api = (await import("./api")).default;
  const r = await api.get(`/catalog/trims?${params}`);
  return r.data?.trims || [];
}

export async function decodeVin(vin) {
  const api = (await import("./api")).default;
  const r = await api.post("/catalog/decode-vin", { vin: vin.trim() });
  return r.data;
}
